import { render, staticRenderFns } from "./BuildingSubdivision.global.vue?vue&type=template&id=77d583c8&scoped=true&lang=pug&"
import script from "./BuildingSubdivision.global.vue?vue&type=script&lang=ts&"
export * from "./BuildingSubdivision.global.vue?vue&type=script&lang=ts&"
import style0 from "./BuildingSubdivision.global.vue?vue&type=style&index=0&id=77d583c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d583c8",
  null
  
)

export default component.exports